<template>
    <div>
        <b-form-group :label="label" label-for="unit-of-measurement">
            <Select
                id="unit-of-measurement"
                :state="state"
                :selected="value"
                :options="unitOfMeasurementOptions"
                @changeValue="onChangeUnitOfMeasurement"
                :disabled="disabled"
                :allowEmpty="true"
            />
        </b-form-group>
        <b-collapse
            v-model="showNewUnitOfMeasurement"
            id="newUnitOfMeasurement"
        >
            <b-card>
                <FormUnitsOfMeasurement
                    :isInCollapse="true"
                    @onSubmit="saveNewUnitOfMeasurement"
                    @canceled="onCancelNewUnitOfMeasurement"
                />
            </b-card>
        </b-collapse>
    </div>
</template>

<script>
import i18n from '@/i18n'
import api from '@/services/api'
import notification, { success, danger } from '@/lib/notification'
import { Form as FormUnitsOfMeasurement } from '@/views/units-of-measurement/'
import {
    Select,
    mapperToOption,
    mapperToOptions,
} from '@/views/components/selects'

notification.init()

export default {
    name: 'UnitsOfMeasurement',
    components: {
        Select,
        FormUnitsOfMeasurement,
    },
    props: ['value', 'state', 'disabled', 'label'],
    data() {
        return {
            unitOfMeasurementOptions: [],
            showNewUnitOfMeasurement: false,
            newUnitOfMeasurement: 'newUnitOfMeasurement',
        }
    },
    mounted() {
        this.getUnitsOfMeasurementFromAPI()
    },
    methods: {
        emitChangeValue(newValue) {
            this.$emit('update:value', newValue)
        },
        onChangeUnitOfMeasurement(values) {
            this.addUnitOfMeasurement(values && values.value)
            this.emitChangeValue(values)
        },
        addUnitOfMeasurement(event) {
            this.showNewUnitOfMeasurement = event === this.newUnitOfMeasurement
        },
        getUnitsOfMeasurementFromAPI() {
            return api
                .get('/units-of-measurement', {
                    params: {
                        all: 1,
                        ascending: 1,
                        orderBy: 'title',
                    },
                })
                .then(resp => {
                    const {
                        data: {
                            data: { data },
                        },
                    } = resp
                    this.unitOfMeasurementOptions = [
                        {
                            icon: 'plus-circle',
                            value: this.newUnitOfMeasurement,
                            label: i18n.t('form.button.add'),
                        },
                        ...mapperToOptions(data),
                    ]
                })
                .catch(e => {
                    console.log(e)
                })
                .finally(() => {
                    this.$emit('ready', true)
                })
        },
        saveNewUnitOfMeasurement(form, onReset, isLoading) {
            isLoading(true)
            api.post('/units-of-measurement', form)
                .then(resp => {
                    onReset()
                    const {
                        data: { data },
                    } = resp
                    this.getUnitsOfMeasurementFromAPI().then(() => {
                        this.emitChangeValue(mapperToOption(data))
                        notificationUnitOfMeasurementCreatedSuccessfully()
                    })
                })
                .catch(e => {
                    console.log(e)
                    notificationError()
                })
                .finally(() => {
                    isLoading(false)
                    this.showNewUnitOfMeasurement = false
                })

            const notificationUnitOfMeasurementCreatedSuccessfully = () => {
                success(
                    i18n.t('notification.createdSuccessfully', {
                        item: i18n.t('unitsOfMeasurement.unitOfMeasurement'),
                    })
                )
            }
            const notificationError = () => {
                danger()
            }
        },
        onCancelNewUnitOfMeasurement(reset) {
            reset()
            this.emitChangeValue(null)
            this.showNewUnitOfMeasurement = false
        },
    },
}
</script>
